import React from "react";
import Nav from "../../components/shared/Nav/Nav";
import TopFooter from "../../components/shared/TopFooter/TopFooter";
import Footer from "../../components/shared/Footer/Footer";
import Banner from "../../components/pages/Mobile/Banner/Banner";
import Eye from "../../components/pages/Mobile/Eye/Eye";
import Track from "../../components/pages/Mobile/Track/Track";
import Manage from "../../components/pages/Mobile/Manage/Manage";
import Statistics from "../../components/pages/Mobile/Statistics/Statistics";
import Publishers from "../../components/pages/Mobile/Publishers/Publishers";
import Download from "../../components/pages/Mobile/Download/Download";
const Mobile = () => {
  return (
    <div className="mobile-page">
      <Nav />
      <Banner />
      <Eye />
      <Track />
      <Manage />
      <Statistics />
      <Publishers />
      <Download />
      <TopFooter />
      <Footer />
    </div>
  );
};

export default Mobile;
